import styled, { css } from "styled-components";
import {
  Body,
  semanticGreen,
  shade300,
  shade800,
  shade950,
} from "@songtradr-one/components-frontend";
import { FragmentType, graphql } from "../../../generated/gql";
import { NotificationItemFragment } from "../../../generated/gql/graphql";
import { notificationMessages } from "../../statics/notification-messages";

// TEXT

// STYLES
export const Wrapper = styled.div<{ $clickable: boolean }>(
  ({ $clickable }) => css`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    width: 100%;
    padding: 0.5rem 1.5rem 0.75rem;
    background: ${shade950};
    border: none;
    cursor: ${$clickable ? "pointer" : "default"};

    &:hover {
      background: ${shade800};
    }
  `,
);

export const Content = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
`;

export const TimeText = styled(Body)`
  color: ${shade300};
`;

export const UnreadDot = styled.div`
  flex-shrink: 0;
  width: 0.5rem;
  height: 0.5rem;
  background: ${semanticGreen};
  border-radius: 100%;
`;

// DATA
export const NotificationItem_NotificationFragment = graphql(`
  fragment NotificationItem on Notification {
    id
    status
    date
    key
    subject {
      name
      avatar
    }
    data {
      key
      value
    }
    dest
  }
`);

export const NotificationItem_MarkAsRead = graphql(`
  mutation NotificationItemMarkAsRead($id: ID!) {
    markNotificationAsRead(id: $id)
  }
`);

// TYPES
export type Props = {
  notification: FragmentType<typeof NotificationItem_NotificationFragment>;
  /** Called right before navigating to a notification's dest, so the panel
   * that's rendering this item can close itself rather than staying open
   * over the page it just navigated to. */
  onNavigate?: () => void;
};

// CONSTANTS
export const DEFAULT_SUBJECT_TEXT = "Your";

// FUNCTIONS
export const getTemplateProps = ({ key, data }: NotificationItemFragment) => {
  const vars = Object.fromEntries(data?.map((d) => [d.key, d.value]) ?? []);
  return { ...notificationMessages[key], vars };
};

// ASSETS
